var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"List"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.typeTitle))]),_c('VoteList',{attrs:{"listType":this.$route.query.type}}),_c('div',{staticStyle:{"height":"60px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }